import { ChatOpenerSubscriber } from '@atlassian/conversation-assistant';
import { ChatContextSubscriber } from '@atlassian/conversation-assistant-store';
import React from 'react';
import { ErrorBoundary } from '@townsquare/monitoring/error-boundary';

import { useRovoEntitlement } from '@townsquare/rovo/entitlement';

import { useHandleOpenPanel } from '../hooks/useHandleOpenPanel';

const RovoChatSubscribersInner = () => {
	const { data, loading } = useRovoEntitlement();
	const { handleOpenPanel } = useHandleOpenPanel();

	if (!data?.isRovoLLMEnabled || loading) {
		return null;
	}

	return (
		<>
			<ChatContextSubscriber />
			<ChatOpenerSubscriber onTriggerOpeningChat={(_conversationId, openChatMode) => handleOpenPanel(openChatMode)} />
		</>
	);
};

export const RovoChatSubscribers = () => (
	<ErrorBoundary fallback={null}>
		<RovoChatSubscribersInner />
	</ErrorBoundary>
);
